import React from 'react';
import './RecipeOfTheDay.css';
import { normalizarTexto } from './Utils/textUtils';
import { useNavigate } from 'react-router-dom';
import { Banner } from '../interfaces/Banner.interface';

interface BannerProps {
  banner: Banner;
}
const RecipeOfTheDay: React.FC<BannerProps> = ({ banner }) => {

  const navigate = useNavigate();
  const handleViewRecipe = () => {
  const slug = normalizarTexto(banner.nombreReceta);
    navigate(`/recetas/${slug}`);
  };
  return (
    <div className="recipe-container" onClick={handleViewRecipe}>
      <img src={banner.urlImagenBanner} alt="Recipe of the Day" className="recipe-image" />
    </div>
  );
};

export default RecipeOfTheDay;
